
export const maxNumberOfHeaders: number = 10;
export const headerScrollStep: number = 100;

export enum FilterModes {
  NotFiltered = 'NotFiltered',
  Filtered = 'Filtered',
  Selected = 'Selected'
}

export enum Tabs {
  AberrationInfoTabName = 'aberration-info',
  GenomeViewerTabName = 'genome-viewer',
  AberrationNotesTabName = 'aberration-notes',
}

export interface AberrationsFilter {
  mode: FilterModes;
  filterQueryString: string;
}

export interface TabConfig {
  name: string;
  configuration?: any;
}

export interface AberrationExtraDetailsConfig {
  allowSelections: boolean;
  tabs: TabConfig[];
}

export interface Header {
  name: string;
  type: string;
  columnData: any;
  values: any[];
}

export const AberrationClassMap = {
  wildtype: 'WildType',
  snv: 'SNV',
  cnv: 'CNV',
  fusions: 'Fusion',
  rnasplicevariants: 'RnaSpliceVariants'
};
